// export const startUrl = `/`;

const commonApi = process.env.REACT_APP_API_BASE_URL || "http://localhost/Quickcard/quickcard_api-main/";

export const methodGet = "GET";
export const methodPost = "post";

const send_otp = `${commonApi}send_otp`;

const validate_otp = `${commonApi}validate_otp`;

const user_signup = `${commonApi}user_signup`;

const user_signin = `${commonApi}user_signin`;

const forgot_password = `${commonApi}forgot_password`;

const reset_password = `${commonApi}reset_password`;

const forgot_pwd_otp = `${commonApi}forgot_pwd_otp`;

const read_card = `${commonApi}read_card`;

const get_all_data = `${commonApi}get_all_data`;

const add_template = `${commonApi}add_template`;

const delete_template = `${commonApi}delete_template`;

const delete_templates = `${commonApi}delete_templates`;

const get_all_templates = `${commonApi}get_all_templates`;

const get_template = `${commonApi}get_template`;

const edit_template = `${commonApi}edit_template`;

const delete_card_data = `${commonApi}delete_card_data`;

const update_card_data = `${commonApi}update_card_data`;

const get_card_data = `${commonApi}get_card_data`;

const get_email_logs = `${commonApi}get_email_logs`;

const get_profile_data = `${commonApi}get_profile_data`;

export const get_fillers = `${commonApi}get_fillers`;
export const add_filler = `${commonApi}add_filler`;
export const edit_filler = `${commonApi}edit_filler`;
export const delete_filler = `${commonApi}delete_filler`;

const update_profile_data = `${commonApi}update_profile_data`;

const save_smtp_settings = `${commonApi}save_smtp_settings`;

const get_smtp_settings = `${commonApi}get_smtp_settings`;

const delete_smtp_settings = `${commonApi}delete_smtp_settings`;

const send_email = `${commonApi}send_email`;
const render_template = `${commonApi}render_template`;
const preview_email = `${commonApi}preview_email`;
export const generate_ai_email = `${commonApi}generate_ai_email`;

const create_razorpay_order = `${commonApi}create_razorpay_order`;
const verify_payment = `${commonApi}verify_payment`;

const get_admin_users = `${commonApi}get_admin_users`;
const get_admin_stats = `${commonApi}get_admin_stats`;

export const admin_delete_user = `${commonApi}admin_delete_user`;
export const admin_update_user = `${commonApi}admin_update_user`;

const get_user_plan = `${commonApi}get_user_plan`;
const upgrade_plan = `${commonApi}upgrade_plan`;
const get_admin_payments = `${commonApi}get_admin_payments`;
const get_admin_plans = `${commonApi}get_admin_plans`;
const update_admin_plan = `${commonApi}update_admin_plan`;
const get_admin_logs = `${commonApi}get_admin_logs`;
const schedule_downgrade = `${commonApi}schedule_downgrade`;

export {
  commonApi,
  send_otp,
  validate_otp,
  user_signup,
  user_signin,
  forgot_password,
  forgot_pwd_otp,
  read_card,
  get_all_data,
  reset_password,
  add_template,
  delete_template,
  get_all_templates,
  edit_template,
  get_template,
  render_template,
  preview_email,
  delete_templates,
  delete_card_data,
  update_card_data,
  get_card_data,
  get_profile_data,
  update_profile_data,
  save_smtp_settings,
  get_smtp_settings,
  delete_smtp_settings,
  send_email,
  create_razorpay_order,
  verify_payment,
  get_admin_users,
  get_admin_stats,
  get_user_plan,
  upgrade_plan,
  get_admin_payments,
  get_admin_plans,
  update_admin_plan,
  get_admin_logs,
  get_email_logs,
  schedule_downgrade
};
